/* eslint-disabled */

export default class EngineConditionExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
